import { createContext } from 'react';

/**
 * Figures call this while a sparkline tooltip is open so the figure and the
 * health row can rise above later siblings. The default does nothing when a
 * sparkline is rendered outside that row.
 */
export const SparklineTooltipLayerContext = createContext<(open: boolean) => void>(() => {});
